import React from 'react';

import FormHelperText from '@mui/material/FormHelperText';

const TextInfo = ({ text, error }) => {
  return <FormHelperText error={!!error}>{text}</FormHelperText>;
};

export default TextInfo;
